import { useState } from "react";
import { Button } from "V2.0/common/button";
import { PlusIcon } from "@heroicons/react/24/outline";

import KeyValuePairsTable from "../Components/KeyValuePairs/KeyValuePairsTable";
import useKeyValuePairsForm from "../Components/KeyValuePairs/useKeyValuePairsForm";
import KeyValuePairFormDialog from "../Components/KeyValuePairs/KeyValuePairFormDialog";

export default function QueryParams(props) {
  const { queryParams, onUpdate } = props;

  const [queryParamDialog, setQueryParamDialog] = useState({
    mode: undefined,
    key: "",
    value: "",
  });

  const { addKeyValuePair, removeKeyValuePair, updateKeyValuePair } =
    useKeyValuePairsForm(queryParams, onUpdate);

  return (
    <>
      <div className="flex flex-col gap-y-2">
        <div className="flex items-center justify-between">
          <p className="text-sm font-semibold">Query Parameters</p>
          <Button
            outline
            onClick={() =>
              setQueryParamDialog({ mode: "add", key: "", value: "" })
            }
          >
            <PlusIcon /> Parameter
          </Button>
        </div>
        <div>
          <KeyValuePairsTable
            keyValuePairs={queryParams}
            onKeyValuePairEdit={(key, value) => {
              setQueryParamDialog({ mode: "edit", key, value });
            }}
            onKeyValuePairRemove={(key) => removeKeyValuePair(key)}
          />
        </div>
      </div>
      {queryParamDialog.mode && (
        <KeyValuePairFormDialog
          title="Parameter"
          mode={queryParamDialog.mode}
          keyValuePair={{
            key: queryParamDialog.key,
            value: queryParamDialog.value,
          }}
          onAdd={addKeyValuePair}
          onUpdate={updateKeyValuePair}
          onClose={() =>
            setQueryParamDialog({ mode: undefined, key: "", value: "" })
          }
        />
      )}
    </>
  );
}
